var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.0001 12.8198L35.1801 9.99976L24.0001 21.1798L12.8201 9.99976L10.0001 12.8198L21.1801 23.9998L10.0001 35.1798L12.8201 37.9998L24.0001 26.8198L35.1801 37.9998L38.0001 35.1798L26.8201 23.9998L38.0001 12.8198Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIconWhite);
export default __webpack_public_path__ + "static/media/closeIconWhite.d379a1bf681db6b5da92b03efda86f14.svg";
export { ForwardRef as ReactComponent };